module.exports = __webpack_public_path__ + "static/media/NotoSansTC-Black-Alphabetic.c154fb88.woff";